var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.file.path)?_c('div',[_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.download}},[_c('v-icon',[_vm._v("mdi-file-download")])],1),(_vm.deleteDocs)?_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.deleteDocument}},[_c('v-icon',[_vm._v("mdi-delete-circle-outline")])],1):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }